import React, { useState, useEffect } from "react";

// components
import BottomBar from "src/components/common/BottomBar";
import Notification from "src/components/Notification";

const BottomNavigationLayout = ({ children }) => {
  const [isMobView, setIsMobView] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    listenToResize();

    window.addEventListener("resize", listenToResize);
    return () => window.removeEventListener("resize", listenToResize);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listenToResize = () => {
    if (window.innerWidth < 640) setIsMobView(true);
    else {
      if (isMobView) setIsMobView(false);
    }
  };

  const showNotification = () => {
    setIsOpen(true);
    setTimeout(() => {
      document.body.classList.add("set-y");
    }, 500);
  };

  return (
    <div>
      {children}
      {isMobView && <BottomBar handleClick={showNotification} />}
      {isMobView && (
        <Notification isOpen={isOpen} setIsOpen={setIsOpen} isMobView />
      )}
    </div>
  );
};

export default BottomNavigationLayout;
